import { render, staticRenderFns } from "./parcel-update.vue?vue&type=template&id=4d4b46e9"
import script from "./parcel-update.vue?vue&type=script&lang=js"
export * from "./parcel-update.vue?vue&type=script&lang=js"
import style0 from "./parcel-update.vue?vue&type=style&index=0&id=4d4b46e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports